import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2c44c0e4 = () => interopDefault(import('../pages/confirm-email-update.vue' /* webpackChunkName: "pages/confirm-email-update" */))
const _7e3c52f2 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _d341d85e = () => interopDefault(import('../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _2e5d90ba = () => interopDefault(import('../pages/reset-password/index.vue' /* webpackChunkName: "pages/reset-password/index" */))
const _ec7fb622 = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _781281a1 = () => interopDefault(import('../pages/select-professional.vue' /* webpackChunkName: "pages/select-professional" */))
const _f7f9b320 = () => interopDefault(import('../pages/select-role.vue' /* webpackChunkName: "pages/select-role" */))
const _4a9ffef4 = () => interopDefault(import('../pages/sign-up.vue' /* webpackChunkName: "pages/sign-up" */))
const _7c05e483 = () => interopDefault(import('../pages/types.ts' /* webpackChunkName: "pages/types" */))
const _47cf6f8a = () => interopDefault(import('../pages/user-details/index.vue' /* webpackChunkName: "pages/user-details/index" */))
const _12de594f = () => interopDefault(import('../pages/verify-email.vue' /* webpackChunkName: "pages/verify-email" */))
const _5e9b431a = () => interopDefault(import('../pages/you-are-in.vue' /* webpackChunkName: "pages/you-are-in" */))
const _2e38e3fc = () => interopDefault(import('../pages/customer/my-cases.vue' /* webpackChunkName: "pages/customer/my-cases" */))
const _aa12de02 = () => interopDefault(import('../pages/customer/profile.vue' /* webpackChunkName: "pages/customer/profile" */))
const _33c700b7 = () => interopDefault(import('../pages/professional/customers/index.vue' /* webpackChunkName: "pages/professional/customers/index" */))
const _43c7a3d3 = () => interopDefault(import('../pages/professional/my-cases.vue' /* webpackChunkName: "pages/professional/my-cases" */))
const _45960b70 = () => interopDefault(import('../pages/professional/profile.vue' /* webpackChunkName: "pages/professional/profile" */))
const _2ccf70a0 = () => interopDefault(import('../pages/reset-password/request.vue' /* webpackChunkName: "pages/reset-password/request" */))
const _03bbc4df = () => interopDefault(import('../pages/professional/customers/_id.vue' /* webpackChunkName: "pages/professional/customers/_id" */))
const _7e7a50e6 = () => interopDefault(import('../pages/chat/_id/index.vue' /* webpackChunkName: "pages/chat/_id/index" */))
const _2f441224 = () => interopDefault(import('../pages/p/_id.vue' /* webpackChunkName: "pages/p/_id" */))
const _7912a878 = () => interopDefault(import('../pages/chat/_id/payment/index.vue' /* webpackChunkName: "pages/chat/_id/payment/index" */))
const _96d6a04a = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/confirm-email-update",
    component: _2c44c0e4,
    name: "confirm-email-update"
  }, {
    path: "/login",
    component: _7e3c52f2,
    name: "login"
  }, {
    path: "/logout",
    component: _d341d85e,
    name: "logout"
  }, {
    path: "/reset-password",
    component: _2e5d90ba,
    name: "reset-password"
  }, {
    path: "/search",
    component: _ec7fb622,
    name: "search"
  }, {
    path: "/select-professional",
    component: _781281a1,
    name: "select-professional"
  }, {
    path: "/select-role",
    component: _f7f9b320,
    name: "select-role"
  }, {
    path: "/sign-up",
    component: _4a9ffef4,
    name: "sign-up"
  }, {
    path: "/types",
    component: _7c05e483,
    name: "types"
  }, {
    path: "/user-details",
    component: _47cf6f8a,
    name: "user-details"
  }, {
    path: "/verify-email",
    component: _12de594f,
    name: "verify-email"
  }, {
    path: "/you-are-in",
    component: _5e9b431a,
    name: "you-are-in"
  }, {
    path: "/customer/my-cases",
    component: _2e38e3fc,
    name: "customer-my-cases"
  }, {
    path: "/customer/profile",
    component: _aa12de02,
    name: "customer-profile"
  }, {
    path: "/professional/customers",
    component: _33c700b7,
    name: "professional-customers"
  }, {
    path: "/professional/my-cases",
    component: _43c7a3d3,
    name: "professional-my-cases"
  }, {
    path: "/professional/profile",
    component: _45960b70,
    name: "professional-profile"
  }, {
    path: "/reset-password/request",
    component: _2ccf70a0,
    name: "reset-password-request"
  }, {
    path: "/professional/customers/:id",
    component: _03bbc4df,
    name: "professional-customers-id"
  }, {
    path: "/chat/:id",
    component: _7e7a50e6,
    name: "chat-id"
  }, {
    path: "/p/:id?",
    component: _2f441224,
    name: "p-id"
  }, {
    path: "/chat/:id?/payment",
    component: _7912a878,
    name: "chat-id-payment"
  }, {
    path: "/",
    component: _96d6a04a,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
